import {
  BigNumber,
} from 'ethers'

export const encodeTokenId = (
  seriesId: BigNumber,
  tokenId: BigNumber,
): BigNumber => {
  let ret = seriesId.shl(32)
  ret = ret.xor(tokenId)
  return ret
}

export const extractSeriesId = (
  tokenId: BigNumber,
): BigNumber => tokenId.shr(32).mask(16)

export const extractTokenId = (
  tokenId: BigNumber,
): BigNumber => tokenId.mask(32)

export const encodeTokenIdOldStyle = (
  artistId: BigNumber,
  seriesId: BigNumber,
  groupId: BigNumber,
  tokenId: BigNumber,
): BigNumber => {
  let ret = artistId.shl(192)
  ret = ret.xor(seriesId.shl(128))
  ret = ret.xor(groupId.shl(64))
  ret = ret.xor(tokenId)
  return ret
}
